export enum VISIBILITY {
  VISIBLE = `visibility`,
  NONE = `visibility_off`,
}
